import { computed, inject, Injectable } from '@angular/core';

import { AdminModeService } from '../admin-mode/admin-mode.service';
import { UserService } from '../user/user.service';

@Injectable({
  // not providedIn: 'root', so that it is not automatically instantiated in tests
  providedIn: null,
})
export class DealerProvider {
  private readonly userService = inject(UserService);
  private readonly adminModeService = inject(AdminModeService);

  /**
   * A signal that returns the active country code,
   * either based on the user or the country of the admin’s chosen outlet.
   *
   * This is undefined if the user is not loaded yet.
   */
  readonly activeCountry = computed(
    () => this.adminModeService.activeAdminCountry() ?? this.userService.userSignal()?.countryCode,
  );

  readonly activeDpNr = computed(
    () => this.adminModeService.activeAdminDpNr() ?? this.userService.userSignal()?.distributionPartnerNumber,
  );
}
